import { webpushFullSettingsHeader } from './NotificationsOptions.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { getOwaWorkload, OwaWorkload } from 'owa-workloads';
import { isWebPushNotificationSupported } from 'owa-webpush-notifications';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
let NotificationsOptions: LazyOption = createLazyOption(
    {
        key: 'browserNotifications',
        titleStringKey: webpushFullSettingsHeader,
        searchTermsStringKey: webpushFullSettingsHeader,
        isHidden: () =>
            !(getOwaWorkload() == OwaWorkload.Mail && isWebPushNotificationSupported(window)),
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default NotificationsOptions;
